// @generated by codegen v0.0.0 with parameter "target=ts,service.creativefabrica.studioagent=VITE_RPC_STUDIOAGENT_URL,service.creativefabrica.preset=VITE_RPC_PRESET_URL,include.creativefabrica.studioagent.v1.StudioAgentService.ListConversations=infiniteQuery,include.creativefabrica.studioagent.v1.StudioAgentService.CreateConversation=mutation,include.creativefabrica.studioagent.v1.StudioAgentService.DeleteConversation=mutation,include.creativefabrica.studioagent.v1.StudioAgentService.GetConversation=query,include.creativefabrica.studioagent.v1.StudioAgentService.ListMessages=infiniteQuery,include.creativefabrica.studioagent.v1.StudioAgentService.SendMessage=mutation,include.creativefabrica.studioagent.v1.StudioAgentService.ResolveMessageAction=mutation,include.creativefabrica.studioagent.v1.StudioAgentService.PrepareConversationUploads=mutation,include.creativefabrica.studioagent.v1.StudioAgentService.RegisterExternalAsset=mutation,include.creativefabrica.studioagent.v1.StudioAgentService.ImportWebMedia=mutation,include.creativefabrica.studioagent.v1.StudioAgentService.ListConversationRefs=query,include.creativefabrica.studioagent.v1.StudioAgentService.BatchGetInputRefs=query,include.creativefabrica.studioagent.v1.StudioAgentService.ListGenerationModels=query,include.creativefabrica.preset.v1.AIProviderService.CalculateModelCost=query"
// @generated from file creativefabrica/studioagent/v1/service.proto (package creativefabrica.studioagent.v1, syntax proto3)
/* eslint-disable */

import type { InfiniteData, UseInfiniteQueryOptions, UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import { createClient } from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";
import type { MessageInitShape } from "@bufbuild/protobuf";

import invariant from 'tiny-invariant'

import { interceptors } from '@repo/rpc-codegen/interceptors'
import { createCallOptions } from '@repo/rpc-codegen/sensitive-call'

import { StudioAgentService, CreateConversationResponse, CreateConversationRequestSchema, ListConversationsResponse, ListConversationsRequestSchema, GetConversationResponse, GetConversationRequestSchema, ListMessagesResponse, ListMessagesRequestSchema, DeleteConversationResponse, DeleteConversationRequestSchema, SendMessageResponse, SendMessageRequestSchema, PrepareConversationUploadsResponse, PrepareConversationUploadsRequestSchema, RegisterExternalAssetResponse, RegisterExternalAssetRequestSchema, ImportWebMediaResponse, ImportWebMediaRequestSchema, ResolveMessageActionResponse, ResolveMessageActionRequestSchema, ListConversationRefsResponse, ListConversationRefsRequestSchema, BatchGetInputRefsResponse, BatchGetInputRefsRequestSchema, ListGenerationModelsResponse, ListGenerationModelsRequestSchema } from "./service_pb";

/**
 * This file contains generated TanStack Query hooks for the gRPC services defined in service.proto
 */

/**
 * Base type for query keys. Query keys are arrays that uniquely identify a query,
 * consisting of a root key constant and optional variables.
 * @template TVariables - The type of variables that can be included in the query key
 */
type QueryKey<TVariables> = (TVariables | string)[];

/**
 * Base type for query options, containing the query key and query function.
 * @template TResult - The expected result type of the query
 * @template TVariables - The variables type for the query
 */
type QueryOptions<TResult, TVariables> = Pick<UseQueryOptions<TResult, Error, TResult, QueryKey<TVariables>>, 'queryKey' | 'queryFn'>;

/**
 * Hooks and utilities for the StudioAgentService service
 * Service: creativefabrica.studioagent.v1.StudioAgentService
 */

let StudioAgentServiceClient: ReturnType<typeof createClient<typeof StudioAgentService>> | undefined

function getStudioAgentServiceClient() {
  const baseUrl = process.env.VITE_RPC_STUDIOAGENT_URL
  invariant(baseUrl, 'VITE_RPC_STUDIOAGENT_URL env var is not set')
  StudioAgentServiceClient ??= createClient(
    StudioAgentService,
    createConnectTransport({
      baseUrl,
      useBinaryFormat: false,
      interceptors,
    }),
  )
  return StudioAgentServiceClient
}

/**
 * Unique identifier for the CreateConversation mutation
 */
export const CreateConversationMutationKey = 'StudioAgentService.CreateConversation' as const;

/**
 * CreateConversation starts a conversation bound to a character.
 *
 * For an agent with Agent.requires_subscription it fails with
 * FAILED_PRECONDITION when the caller has no active Studio AI subscription;
 * the error carries a creativefabrica.errors.v1.Error detail of type COIN
 * with code COIN_ERROR_CODE_MISSING_AI_STUDIO_SUBSCRIPTION. The check runs
 * once, here: conversations that already exist stay usable.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.CreateConversation
 */
/**
 * Function to execute the CreateConversation RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function createConversationFn(variables: MessageInitShape<typeof CreateConversationRequestSchema>, meta?: Record<string, unknown>): Promise<CreateConversationResponse> {
  return getStudioAgentServiceClient().createConversation(variables, createCallOptions(meta));
}


/**
 * CreateConversation starts a conversation bound to a character.
 *
 * For an agent with Agent.requires_subscription it fails with
 * FAILED_PRECONDITION when the caller has no active Studio AI subscription;
 * the error carries a creativefabrica.errors.v1.Error detail of type COIN
 * with code COIN_ERROR_CODE_MISSING_AI_STUDIO_SUBSCRIPTION. The check runs
 * once, here: conversations that already exist stay usable.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.CreateConversation
 */
export function useCreateConversationMutation(options?: Omit<
  UseMutationOptions<
    CreateConversationResponse,
    Error,
    MessageInitShape<typeof CreateConversationRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    CreateConversationResponse,
    Error,
    MessageInitShape<typeof CreateConversationRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => createConversationFn(variables, options?.meta),
    mutationKey: [CreateConversationMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the ListConversations infinite query
 */
export const ListConversationsQueryRootKey = 'StudioAgentService.ListConversations' as const;

/**
 * ListConversations returns the caller's conversations, most-recent first.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ListConversations
 */
/**
 * Function to execute the ListConversations RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function listConversationsFn(variables: MessageInitShape<typeof ListConversationsRequestSchema>, meta?: Record<string, unknown>) {
  return getStudioAgentServiceClient().listConversations(variables, createCallOptions(meta));
}

export function useListConversationsInfiniteQuery<D = ListConversationsResponse>(
  variables: MessageInitShape<typeof ListConversationsRequestSchema>,
  options?: Omit<
    UseInfiniteQueryOptions<
      ListConversationsResponse,
      Error,
      InfiniteData<D, string | undefined>,
      string[],
      string | undefined
    >,
    'queryKey' | 'queryFn' | 'initialPageParam' | 'getNextPageParam'
  > & {
    initialPageParam?: string | undefined
  },
) {
  const { pagination, ...otherVariables } = variables
  return useInfiniteQuery({
    queryKey: [ListConversationsQueryRootKey, JSON.stringify(otherVariables)],
    initialPageParam: undefined,
    getNextPageParam: lastPage => lastPage.pagination?.next?.value === "" ? null : lastPage.pagination?.next?.value ?? null,
    queryFn: ({ pageParam, meta }) => {
      const queryOptions: MessageInitShape<typeof ListConversationsRequestSchema> = {
        ...variables,
      }
      if (pagination) {
        queryOptions.pagination = pagination
      }
      if (pageParam) {
        queryOptions.pagination = {
          ...pagination,
          after: {
            '$typeName': 'creativefabrica.common.v1.Cursor',
            value: pageParam
          }
        }
      }
      return listConversationsFn(queryOptions, meta)
    },
    ...options,
  })
}

/**
 * ListConversations returns the caller's conversations, most-recent first.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ListConversations
 */

/**
 * Unique identifier for the GetConversation query
 */
export const GetConversationQueryRootKey = 'StudioAgentService.GetConversation' as const;

/**
 * Return type for the GetConversation query
 */
type GetConversationQueryResult = GetConversationResponse;

/**
 * Generates a unique query key for the GetConversation query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `GetConversationQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const getConversationQueryKey = /*@__PURE__*/ function getConversationQueryKey(variables?: MessageInitShape<typeof GetConversationRequestSchema>): QueryKey<MessageInitShape<typeof GetConversationRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof GetConversationRequestSchema>> = [GetConversationQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * GetConversation returns a conversation with its messages.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.GetConversation
 */
/**
 * Function to execute the GetConversation RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function getConversationFn(variables: MessageInitShape<typeof GetConversationRequestSchema>, meta?: Record<string, unknown>): Promise<GetConversationResponse> {
  return getStudioAgentServiceClient().getConversation(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the GetConversation query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = getConversationQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useGetConversationQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const getConversationQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof GetConversationRequestSchema>): QueryOptions<GetConversationQueryResult, MessageInitShape<typeof GetConversationRequestSchema>> {
  return {
    queryKey: getConversationQueryKey(variables),
    queryFn: async (context) => getConversationFn(variables, context.meta)
  };
};


/**
 * GetConversation returns a conversation with its messages.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.GetConversation
 */
export function useGetConversationQuery<D = GetConversationQueryResult, E = Error>(variables: MessageInitShape<typeof GetConversationRequestSchema>, options?: Omit<
  UseQueryOptions<
    GetConversationQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetConversationRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    GetConversationQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof GetConversationRequestSchema>>
  >({
    ...options,
    ...getConversationQueryOptions(variables),
  });
}

/**
 * Unique identifier for the ListMessages infinite query
 */
export const ListMessagesQueryRootKey = 'StudioAgentService.ListMessages' as const;

/**
 * ListMessages pages BACKWARDS through a conversation's history for infinite
 * scroll: each page returns the most recent messages before the cursor,
 * newest-first within the page. GetConversation serves the initial recent
 * window; the cursor from each ListMessages page loads the one before it.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ListMessages
 */
/**
 * Function to execute the ListMessages RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function listMessagesFn(variables: MessageInitShape<typeof ListMessagesRequestSchema>, meta?: Record<string, unknown>) {
  return getStudioAgentServiceClient().listMessages(variables, createCallOptions(meta));
}

export function useListMessagesInfiniteQuery<D = ListMessagesResponse>(
  variables: MessageInitShape<typeof ListMessagesRequestSchema>,
  options?: Omit<
    UseInfiniteQueryOptions<
      ListMessagesResponse,
      Error,
      InfiniteData<D, string | undefined>,
      string[],
      string | undefined
    >,
    'queryKey' | 'queryFn' | 'initialPageParam' | 'getNextPageParam'
  > & {
    initialPageParam?: string | undefined
  },
) {
  const { pagination, ...otherVariables } = variables
  return useInfiniteQuery({
    queryKey: [ListMessagesQueryRootKey, JSON.stringify(otherVariables)],
    initialPageParam: undefined,
    getNextPageParam: lastPage => lastPage.pagination?.next?.value === "" ? null : lastPage.pagination?.next?.value ?? null,
    queryFn: ({ pageParam, meta }) => {
      const queryOptions: MessageInitShape<typeof ListMessagesRequestSchema> = {
        ...variables,
      }
      if (pagination) {
        queryOptions.pagination = pagination
      }
      if (pageParam) {
        queryOptions.pagination = {
          ...pagination,
          after: {
            '$typeName': 'creativefabrica.common.v1.Cursor',
            value: pageParam
          }
        }
      }
      return listMessagesFn(queryOptions, meta)
    },
    ...options,
  })
}

/**
 * ListMessages pages BACKWARDS through a conversation's history for infinite
 * scroll: each page returns the most recent messages before the cursor,
 * newest-first within the page. GetConversation serves the initial recent
 * window; the cursor from each ListMessages page loads the one before it.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ListMessages
 */

/**
 * Unique identifier for the DeleteConversation mutation
 */
export const DeleteConversationMutationKey = 'StudioAgentService.DeleteConversation' as const;

/**
 * DeleteConversation soft-deletes a conversation.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.DeleteConversation
 */
/**
 * Function to execute the DeleteConversation RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function deleteConversationFn(variables: MessageInitShape<typeof DeleteConversationRequestSchema>, meta?: Record<string, unknown>): Promise<DeleteConversationResponse> {
  return getStudioAgentServiceClient().deleteConversation(variables, createCallOptions(meta));
}


/**
 * DeleteConversation soft-deletes a conversation.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.DeleteConversation
 */
export function useDeleteConversationMutation(options?: Omit<
  UseMutationOptions<
    DeleteConversationResponse,
    Error,
    MessageInitShape<typeof DeleteConversationRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    DeleteConversationResponse,
    Error,
    MessageInitShape<typeof DeleteConversationRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => deleteConversationFn(variables, options?.meta),
    mutationKey: [DeleteConversationMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the SendMessage mutation
 */
export const SendMessageMutationKey = 'StudioAgentService.SendMessage' as const;

/**
 * SendMessage posts a user message and returns an ack; the assistant reply is
 * delivered asynchronously over notifications SSE.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.SendMessage
 */
/**
 * Function to execute the SendMessage RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function sendMessageFn(variables: MessageInitShape<typeof SendMessageRequestSchema>, meta?: Record<string, unknown>): Promise<SendMessageResponse> {
  return getStudioAgentServiceClient().sendMessage(variables, createCallOptions(meta));
}


/**
 * SendMessage posts a user message and returns an ack; the assistant reply is
 * delivered asynchronously over notifications SSE.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.SendMessage
 */
export function useSendMessageMutation(options?: Omit<
  UseMutationOptions<
    SendMessageResponse,
    Error,
    MessageInitShape<typeof SendMessageRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    SendMessageResponse,
    Error,
    MessageInitShape<typeof SendMessageRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => sendMessageFn(variables, options?.meta),
    mutationKey: [SendMessageMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the PrepareConversationUploads mutation
 */
export const PrepareConversationUploadsMutationKey = 'StudioAgentService.PrepareConversationUploads' as const;

/**
 * PrepareConversationUploads registers reusable conversation inputs and
 * returns short-lived HTTP upload forms. It is available only when the
 * conversation's configured agent accepts USER_UPLOAD inputs.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.PrepareConversationUploads
 */
/**
 * Function to execute the PrepareConversationUploads RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function prepareConversationUploadsFn(variables: MessageInitShape<typeof PrepareConversationUploadsRequestSchema>, meta?: Record<string, unknown>): Promise<PrepareConversationUploadsResponse> {
  return getStudioAgentServiceClient().prepareConversationUploads(variables, createCallOptions(meta));
}


/**
 * PrepareConversationUploads registers reusable conversation inputs and
 * returns short-lived HTTP upload forms. It is available only when the
 * conversation's configured agent accepts USER_UPLOAD inputs.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.PrepareConversationUploads
 */
export function usePrepareConversationUploadsMutation(options?: Omit<
  UseMutationOptions<
    PrepareConversationUploadsResponse,
    Error,
    MessageInitShape<typeof PrepareConversationUploadsRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    PrepareConversationUploadsResponse,
    Error,
    MessageInitShape<typeof PrepareConversationUploadsRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => prepareConversationUploadsFn(variables, options?.meta),
    mutationKey: [PrepareConversationUploadsMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the RegisterExternalAsset mutation
 */
export const RegisterExternalAssetMutationKey = 'StudioAgentService.RegisterExternalAsset' as const;

/**
 * RegisterExternalAsset turns a media object another Creative Fabrica
 * product produced (video generator, video editor, flow, …) into a reusable
 * conversation input without a second upload or a coin charge: the object
 * is copied into the agent's private store, probed, and named with the next
 * {{image_N}} / {{video_N}} / {{audio_N}} token with source
 * GENERATED_OUTPUT, so the next turn can mention it. Only objects in the
 * configured Creative Fabrica buckets are accepted; registering the same
 * object again returns the existing token. It is available only when the
 * conversation's configured agent accepts GENERATED_OUTPUT inputs of the
 * object's media type.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.RegisterExternalAsset
 */
/**
 * Function to execute the RegisterExternalAsset RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function registerExternalAssetFn(variables: MessageInitShape<typeof RegisterExternalAssetRequestSchema>, meta?: Record<string, unknown>): Promise<RegisterExternalAssetResponse> {
  return getStudioAgentServiceClient().registerExternalAsset(variables, createCallOptions(meta));
}


/**
 * RegisterExternalAsset turns a media object another Creative Fabrica
 * product produced (video generator, video editor, flow, …) into a reusable
 * conversation input without a second upload or a coin charge: the object
 * is copied into the agent's private store, probed, and named with the next
 * {{image_N}} / {{video_N}} / {{audio_N}} token with source
 * GENERATED_OUTPUT, so the next turn can mention it. Only objects in the
 * configured Creative Fabrica buckets are accepted; registering the same
 * object again returns the existing token. It is available only when the
 * conversation's configured agent accepts GENERATED_OUTPUT inputs of the
 * object's media type.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.RegisterExternalAsset
 */
export function useRegisterExternalAssetMutation(options?: Omit<
  UseMutationOptions<
    RegisterExternalAssetResponse,
    Error,
    MessageInitShape<typeof RegisterExternalAssetRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    RegisterExternalAssetResponse,
    Error,
    MessageInitShape<typeof RegisterExternalAssetRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => registerExternalAssetFn(variables, options?.meta),
    mutationKey: [RegisterExternalAssetMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the ImportWebMedia mutation
 */
export const ImportWebMediaMutationKey = 'StudioAgentService.ImportWebMedia' as const;

/**
 * ImportWebMedia adds media from a public http(s) URL outside Creative
 * Fabrica to the conversation as a reusable {{upload_N}} input with source
 * WEB_IMPORT. It returns at once with the ref PENDING (stage QUEUED); the
 * server then downloads, verifies and stores the file, reporting progress
 * and the outcome through InputRefUpdated notifications and
 * BatchGetInputRefs. Only direct image and video files are accepted; web
 * pages and streams fail with WEB_IMPORT_FAILURE_PAGE_OR_STREAM. Importing
 * a URL the conversation already holds (pending or ready) returns that ref,
 * and repeating a request with the same client_file_id returns the same
 * ref. Available only when the conversation's agent accepts WEB_IMPORT
 * inputs.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ImportWebMedia
 */
/**
 * Function to execute the ImportWebMedia RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function importWebMediaFn(variables: MessageInitShape<typeof ImportWebMediaRequestSchema>, meta?: Record<string, unknown>): Promise<ImportWebMediaResponse> {
  return getStudioAgentServiceClient().importWebMedia(variables, createCallOptions(meta));
}


/**
 * ImportWebMedia adds media from a public http(s) URL outside Creative
 * Fabrica to the conversation as a reusable {{upload_N}} input with source
 * WEB_IMPORT. It returns at once with the ref PENDING (stage QUEUED); the
 * server then downloads, verifies and stores the file, reporting progress
 * and the outcome through InputRefUpdated notifications and
 * BatchGetInputRefs. Only direct image and video files are accepted; web
 * pages and streams fail with WEB_IMPORT_FAILURE_PAGE_OR_STREAM. Importing
 * a URL the conversation already holds (pending or ready) returns that ref,
 * and repeating a request with the same client_file_id returns the same
 * ref. Available only when the conversation's agent accepts WEB_IMPORT
 * inputs.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ImportWebMedia
 */
export function useImportWebMediaMutation(options?: Omit<
  UseMutationOptions<
    ImportWebMediaResponse,
    Error,
    MessageInitShape<typeof ImportWebMediaRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    ImportWebMediaResponse,
    Error,
    MessageInitShape<typeof ImportWebMediaRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => importWebMediaFn(variables, options?.meta),
    mutationKey: [ImportWebMediaMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the ResolveMessageAction mutation
 */
export const ResolveMessageActionMutationKey = 'StudioAgentService.ResolveMessageAction' as const;

/**
 * ResolveMessageAction approves or rejects a pending assistant action.
 * Repeating the same decision is idempotent; the opposite decision fails
 * with FAILED_PRECONDITION.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ResolveMessageAction
 */
/**
 * Function to execute the ResolveMessageAction RPC call directly.
 * 
 * This is a low-level function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you need direct control over the request and response,
 * such as in server-side code. If you just want to do something on the client side,
 * we still recommend going through the queryClient to ensure consistency.
 * 
 * @param variables - The Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function resolveMessageActionFn(variables: MessageInitShape<typeof ResolveMessageActionRequestSchema>, meta?: Record<string, unknown>): Promise<ResolveMessageActionResponse> {
  return getStudioAgentServiceClient().resolveMessageAction(variables, createCallOptions(meta));
}


/**
 * ResolveMessageAction approves or rejects a pending assistant action.
 * Repeating the same decision is idempotent; the opposite decision fails
 * with FAILED_PRECONDITION.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ResolveMessageAction
 */
export function useResolveMessageActionMutation(options?: Omit<
  UseMutationOptions<
    ResolveMessageActionResponse,
    Error,
    MessageInitShape<typeof ResolveMessageActionRequestSchema>,
    unknown
  >, 'mutationFn'>) {
  return useMutation<
    ResolveMessageActionResponse,
    Error,
    MessageInitShape<typeof ResolveMessageActionRequestSchema>,
    unknown
  >({
    mutationFn: (variables) => resolveMessageActionFn(variables, options?.meta),
    mutationKey: [ResolveMessageActionMutationKey],
    ...options,
  });
}

/**
 * Unique identifier for the ListConversationRefs query
 */
export const ListConversationRefsQueryRootKey = 'StudioAgentService.ListConversationRefs' as const;

/**
 * Return type for the ListConversationRefs query
 */
type ListConversationRefsQueryResult = ListConversationRefsResponse;

/**
 * Generates a unique query key for the ListConversationRefs query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `ListConversationRefsQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const listConversationRefsQueryKey = /*@__PURE__*/ function listConversationRefsQueryKey(variables?: MessageInitShape<typeof ListConversationRefsRequestSchema>): QueryKey<MessageInitShape<typeof ListConversationRefsRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof ListConversationRefsRequestSchema>> = [ListConversationRefsQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * ListConversationRefs lists a conversation's reusable upload and generated
 * media registry without fetching the whole conversation — for asset-token
 * pickers ({{upload_N}} / {{image_N}}) and media panels. The legacy
 * generated-output refs remain alongside the product-safe input_refs during
 * migration.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ListConversationRefs
 */
/**
 * Function to execute the ListConversationRefs RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function listConversationRefsFn(variables: MessageInitShape<typeof ListConversationRefsRequestSchema>, meta?: Record<string, unknown>): Promise<ListConversationRefsResponse> {
  return getStudioAgentServiceClient().listConversationRefs(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the ListConversationRefs query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = listConversationRefsQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useListConversationRefsQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const listConversationRefsQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof ListConversationRefsRequestSchema>): QueryOptions<ListConversationRefsQueryResult, MessageInitShape<typeof ListConversationRefsRequestSchema>> {
  return {
    queryKey: listConversationRefsQueryKey(variables),
    queryFn: async (context) => listConversationRefsFn(variables, context.meta)
  };
};


/**
 * ListConversationRefs lists a conversation's reusable upload and generated
 * media registry without fetching the whole conversation — for asset-token
 * pickers ({{upload_N}} / {{image_N}}) and media panels. The legacy
 * generated-output refs remain alongside the product-safe input_refs during
 * migration.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ListConversationRefs
 */
export function useListConversationRefsQuery<D = ListConversationRefsQueryResult, E = Error>(variables: MessageInitShape<typeof ListConversationRefsRequestSchema>, options?: Omit<
  UseQueryOptions<
    ListConversationRefsQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof ListConversationRefsRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    ListConversationRefsQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof ListConversationRefsRequestSchema>>
  >({
    ...options,
    ...listConversationRefsQueryOptions(variables),
  });
}

/**
 * Unique identifier for the BatchGetInputRefs query
 */
export const BatchGetInputRefsQueryRootKey = 'StudioAgentService.BatchGetInputRefs' as const;

/**
 * Return type for the BatchGetInputRefs query
 */
type BatchGetInputRefsQueryResult = BatchGetInputRefsResponse;

/**
 * Generates a unique query key for the BatchGetInputRefs query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `BatchGetInputRefsQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const batchGetInputRefsQueryKey = /*@__PURE__*/ function batchGetInputRefsQueryKey(variables?: MessageInitShape<typeof BatchGetInputRefsRequestSchema>): QueryKey<MessageInitShape<typeof BatchGetInputRefsRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof BatchGetInputRefsRequestSchema>> = [BatchGetInputRefsQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * BatchGetInputRefs returns the current state of specific conversation
 * inputs, for example to refresh pending web imports when a notification
 * was missed. It works for every input ref kind (uploads, web imports,
 * registered assets). Unknown refs are omitted.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.BatchGetInputRefs
 */
/**
 * Function to execute the BatchGetInputRefs RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function batchGetInputRefsFn(variables: MessageInitShape<typeof BatchGetInputRefsRequestSchema>, meta?: Record<string, unknown>): Promise<BatchGetInputRefsResponse> {
  return getStudioAgentServiceClient().batchGetInputRefs(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the BatchGetInputRefs query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = batchGetInputRefsQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useBatchGetInputRefsQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const batchGetInputRefsQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof BatchGetInputRefsRequestSchema>): QueryOptions<BatchGetInputRefsQueryResult, MessageInitShape<typeof BatchGetInputRefsRequestSchema>> {
  return {
    queryKey: batchGetInputRefsQueryKey(variables),
    queryFn: async (context) => batchGetInputRefsFn(variables, context.meta)
  };
};


/**
 * BatchGetInputRefs returns the current state of specific conversation
 * inputs, for example to refresh pending web imports when a notification
 * was missed. It works for every input ref kind (uploads, web imports,
 * registered assets). Unknown refs are omitted.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.BatchGetInputRefs
 */
export function useBatchGetInputRefsQuery<D = BatchGetInputRefsQueryResult, E = Error>(variables: MessageInitShape<typeof BatchGetInputRefsRequestSchema>, options?: Omit<
  UseQueryOptions<
    BatchGetInputRefsQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof BatchGetInputRefsRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    BatchGetInputRefsQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof BatchGetInputRefsRequestSchema>>
  >({
    ...options,
    ...batchGetInputRefsQueryOptions(variables),
  });
}

/**
 * Unique identifier for the ListGenerationModels query
 */
export const ListGenerationModelsQueryRootKey = 'StudioAgentService.ListGenerationModels' as const;

/**
 * Return type for the ListGenerationModels query
 */
type ListGenerationModelsQueryResult = ListGenerationModelsResponse;

/**
 * Generates a unique query key for the ListGenerationModels query with variables.
 * The key includes the root key constant and optional variables.
 * If you don't need variables, you can just import the `ListGenerationModelsQueryRootKey`.
 * 
 * Query keys are used by React Query to identify and deduplicate queries.
 * They're also used for cache invalidation and refetching.
 * 
 * @param variables - Optional variables to include in the query key
 * @returns An array that uniquely identifies this query with these variables
 */
export const listGenerationModelsQueryKey = /*@__PURE__*/ function listGenerationModelsQueryKey(variables?: MessageInitShape<typeof ListGenerationModelsRequestSchema>): QueryKey<MessageInitShape<typeof ListGenerationModelsRequestSchema>> {
  const key: QueryKey<MessageInitShape<typeof ListGenerationModelsRequestSchema>> = [ListGenerationModelsQueryRootKey];
  return variables === undefined ? key : [...key, variables];
}

/**
 * ListGenerationModels returns the generation models a conversation's agent
 * offers, each as genai's own catalog entry — the same
 * creativefabrica.preset.v1.CatalogModel that media-matrix, Flow and
 * Workflows list — so a client builds a model's settings controls, applies
 * its constraint rules and quotes its price exactly as it does for those
 * products. It is the companion of MediaGenerationApproval.model_choices:
 * the card names the models, this call describes them. The catalog view is
 * the conversation's (agent, surface, content mode); the response does not
 * depend on any card, so clients may cache it per conversation and model id.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ListGenerationModels
 */
/**
 * Function to execute the ListGenerationModels RPC call directly.
 * 
 * This is a "low-level" function that sends the request to the server and returns a Promise.
 * For most use cases, prefer using the TanStack Query hooks that provide caching and status management.
 * 
 * Use this function when you do not need the overhead of TanStack Query,
 * such as in server-side code or outside of React components.
 * 
 * For more patterns, consult the documentation in Confluence.
 * 
 * @param variables - Input parameters for the RPC call
 * @param meta - Optional meta with sensitive flag for Sentry logging
 * @returns Promise resolving to the response data
 */
export async function listGenerationModelsFn(variables: MessageInitShape<typeof ListGenerationModelsRequestSchema>, meta?: Record<string, unknown>): Promise<ListGenerationModelsResponse> {
  return getStudioAgentServiceClient().listGenerationModels(variables, createCallOptions(meta));
}

/**
 * Creates React Query options for the ListGenerationModels query.
 * 
 * This function generates an options object that includes:
 * 1. A unique query key for React Query's cache management
 * 2. A query function that makes the actual RPC call
 * 
 * You should use this function when you need to:
 * - Prefetch data before navigation
 * - Create a query for manual execution with queryClient
 * 
 * For example: 
 * ```ts
 * const options = listGenerationModelsQueryOptions({
 *   some: 'value',
 * });
 * 
 * queryClient.prefetchQuery(options);
 * 
 * // or
 * useQueries({
 *   queries: [options]
 * });
 * 
 * ```
 * 
 * See more of this pattern at https://tkdodo.eu/blog/the-query-options-api
 * 
 * For most cases, use the useListGenerationModelsQuery hook directly instead.
 * 
 * @param variables - Input parameters for the RPC call
 */
export const listGenerationModelsQueryOptions = /*@__PURE__*/ function(variables: MessageInitShape<typeof ListGenerationModelsRequestSchema>): QueryOptions<ListGenerationModelsQueryResult, MessageInitShape<typeof ListGenerationModelsRequestSchema>> {
  return {
    queryKey: listGenerationModelsQueryKey(variables),
    queryFn: async (context) => listGenerationModelsFn(variables, context.meta)
  };
};


/**
 * ListGenerationModels returns the generation models a conversation's agent
 * offers, each as genai's own catalog entry — the same
 * creativefabrica.preset.v1.CatalogModel that media-matrix, Flow and
 * Workflows list — so a client builds a model's settings controls, applies
 * its constraint rules and quotes its price exactly as it does for those
 * products. It is the companion of MediaGenerationApproval.model_choices:
 * the card names the models, this call describes them. The catalog view is
 * the conversation's (agent, surface, content mode); the response does not
 * depend on any card, so clients may cache it per conversation and model id.
 *
 * @generated from rpc creativefabrica.studioagent.v1.StudioAgentService.ListGenerationModels
 */
export function useListGenerationModelsQuery<D = ListGenerationModelsQueryResult, E = Error>(variables: MessageInitShape<typeof ListGenerationModelsRequestSchema>, options?: Omit<
  UseQueryOptions<
    ListGenerationModelsQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof ListGenerationModelsRequestSchema>>
  >, 'queryKey' | 'queryFn'>) {
  return useQuery<
    ListGenerationModelsQueryResult,
    E,
    D,
    QueryKey<MessageInitShape<typeof ListGenerationModelsRequestSchema>>
  >({
    ...options,
    ...listGenerationModelsQueryOptions(variables),
  });
}


